module.exports = __webpack_public_path__ + "static/media/fave-feed-post-submitted-live.89c43856.svg";